module.exports = __webpack_public_path__ + "media/images/athletes/1405-92774c0a506a169e35221d308a125524.png";